import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_WORDS_CLOUD, res.data)
  })
)

export const show = async ({ commit }, params) => {
  await services.find(params).then(res => {
    commit(types.SET_WORD_CLOUD, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_WORD_CLOUD, res.data.data)
    return res
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteWordCloud = async ({ commit }, obj) => {
  await services.deleteWordCloud(obj).then(res => {
    return res
  })
}

export const deleteOption = async ({ commit }, obj) => {
  await services.deleteOption(obj).then(res => {
    return res
  })
}
